import React from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
    arrayMove, SortableContext, verticalListSortingStrategy, useSortable,
} from "@dnd-kit/sortable";

import TaskItem from "./TaskItem";
import { useCallback, useEffect } from "react";

function TaskList({
    status,
    tasks,
    taskOrder,
    sensors,
    toggleTaskSelection,
    selectedTasks,
    activeProjectId,
    activeProject,
    activeSubProjectObj,
    employees,
    currentUser,
    updateProject,
    setToastMessage,
    setToastType,
    setCurrentTask,
    setRunningTaskId,
    setEditData,
    setShowDescriptionPopup,
    setSelectedTasks,
    isBelow1280,
    localProjects,
    dragDropTaskMutation,
    activeSubProjectId,
    setTaskOrder,
    nowIST
}) {

    // drag and drop//
    const handleDragEnd = useCallback((status, event) => {
        const { active, over } = event;

        if (!over || active.id === over.id) {
            console.log(" Drag skipped");
            return;
        }

        setTaskOrder((prev) => {
            const currentOrder = prev[status] || [];

            const oldIndex = currentOrder.indexOf(active.id);
            const newIndex = currentOrder.indexOf(over.id);

            if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) {
                return prev;
            }

            const newTaskOrder = arrayMove(currentOrder, oldIndex, newIndex);

            const payload = {
                projectId: activeProjectId,
                status,
                taskOrder: newTaskOrder,
            };

            const subProjectIdToSend =
                activeSubProjectId ||
                activeSubProjectObj?._id ||
                tasks?.[0]?.subProjectId;

            if (activeProject?.isMultiProject && subProjectIdToSend) {
                payload.subProjectId = subProjectIdToSend;
            }

            dragDropTaskMutation.mutate(payload);

            return {
                ...prev,
                [status]: newTaskOrder
            };
        });

    }, [activeProjectId, activeSubProjectId, dragDropTaskMutation]);

    useEffect(() => {
        if (tasks.length) {
            const sorted = [...tasks].sort((a, b) => a.order - b.order);

            setTaskOrder((prev) => ({
                ...prev,
                [status]: sorted.map((t) => t.id),
            }));
        }
    }, [tasks, status]);
    
    if (!tasks.length) return null;

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={(e) => handleDragEnd(status, e)}
        >
            <SortableContext
                items={(taskOrder[status] || []).filter(Boolean)}
                strategy={verticalListSortingStrategy}
            >
                <div className="space-y-2">

                    {/* header */}
                    <div className="flex px-3 py-2 mt-[10px] rounded-md font-medium text-gray-500 text-[12px] sm:text-[14px] items-center">
                        <div className="w-[24px] hidden rs:block"></div>
                        <div className="w-[30px] hidden rs:block"></div>

                        <div className="flex-[2]">Name</div>
                        <div className="flex-1">Assigned</div>
                        <div className="hidden xs:block flex-1">Due Date</div>
                        <div className="flex-1">Priority</div>
                        <div className="hidden xs:block flex-1">Spent Time</div>
                    </div>

                    {(taskOrder[status] || [])
                        .filter((taskId) => tasks.some(t => t.id === taskId))
                        .map((taskId) => {

                            const task = tasks.find((t) => String(t.id) === String(taskId));

                            if (!tasks.length) return null;
                            return task ? (
                                <TaskItem
                                    key={task.id}
                                    task={{
                                        ...task,
                                        projectId: activeProjectId,
                                        subProjectId: activeProject?.isMultiProject
                                            ? activeSubProjectObj?._id
                                            : null,
                                    }}
                                    status={status}
                                    toggleTaskSelection={toggleTaskSelection}
                                    selectedTasks={selectedTasks}
                                    activeProjectId={activeProjectId}
                                    setCurrentTask={setCurrentTask}
                                    setRunningTaskId={setRunningTaskId}
                                    setEditData={setEditData}
                                    setShowDescriptionPopup={setShowDescriptionPopup}
                                    setSelectedTasks={setSelectedTasks}
                                    employees={employees}
                                    currentUser={currentUser}
                                    updateProject={updateProject}
                                    setToastMessage={setToastMessage}
                                    setToastType={setToastType}
                                    isBelow1280={isBelow1280}
                                    nowIST={nowIST}
                                />
                            ) : null;
                        })}
                </div>
            </SortableContext>
        </DndContext>
    );
}

export default React.memo(TaskList);
